import { render } from "./NotFound.vue?vue&type=template&id=6e1e5136&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=6e1e5136&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6e1e5136"

export default script